<template>
  <view>
    <view class="picker-demo-title">basic-picker:</view>
    <cube-date-picker
      wx:ref="picker"
      min="{{min}}"
      max="{{max}}"
      value="{{value}}"
      bindcolumnChange="onColumnChange"
      bindchange="onChange"
    />
    <view class="button-wrapper">
      <cube-button bindclick="getSelected">获取当前选中项</cube-button>
    </view>
    <view class="demo-data" wx:if="{{ selectedInfo.length || changeParams.length }}">
      <block wx:if="{{ selectedInfo.length }}">
        <view class="key">getSelectedInfo 事件返回值：</view>
        <view class="value">
          <view class="value-item" wx:for="{{selectedInfo}}" wx:key="index">
            <view class="item-key">{{item[0]}}</view>
            <view class="item-value">{{item[1]}}</view>
          </view>
        </view>
      </block>
      <block wx:if="{{ changeParams.length }}">
        <view class="key">columnChange 事件参数：</view>
        <view class="value">
          <view wx:for="{{ columnChangeParams }}" wx:key="index">
            <view class="value-number">第{{ index+1 }}次：</view>
            <view class="value-item" wx:for={{item}} wx:for-item="itemChild" wx:for-key="itemIndex" wx:key="itemIndex">
              <view class="item-key">{{itemChild[0]}}</view>
              <view class="item-value">{{itemChild[1]}}</view>
            </view>
          </view>
        </view>
      </block>
      <block wx:if="{{ changeParams.length }}">
        <view class="key">change 事件参数：</view>
        <view class="value">
          <view class="value-item" wx:for="{{changeParams}}" wx:key="index">
            <view class="item-key">{{item[0]}}</view>
            <view class="item-value">{{item[1]}}</view>
          </view>
        </view>
      </block>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
let columnChangeArr = []
createComponent({
  data: {
    title: '日期选择器',
    min: +new Date(2010, 7, 8),
    max: +new Date(2022, 9, 20),
    value: +new Date(2021, 11, 31),
    columnChangeParams: [''],
    changeParams: '',
    selectedInfo: ''
  },
  computed: {
    isShowSelectedInfo() {
      return  !this.selectedInfo
    },
    isShowOther() {
      return  !this.columnChangeParams[0] &&  !this.changeParams
    }
  },
  methods: {
    onColumnChange(e) {
      columnChangeArr.push(Object.entries(e.detail))
    },
    onChange(e) {
      this.columnChangeParams = [...columnChangeArr]
      columnChangeArr = []
      const detail = e.detail
      detail.date = '时间戳：' + Date.parse(detail.date)
      this.changeParams = Object.entries(detail)
    },
    getSelected() {
      const info = this.$refs.picker.getSelectedInfo()
      info.date = '时间戳：' + Date.parse(info.date)
      this.selectedInfo = Object.entries(info)
    }
  }
})
</script>

<style lang="stylus">
.picker-demo-title
  margin-bottom: 8px
.button-wrapper
  margin-top: 10px
.demo-data
  margin-top: 10px
  padding: 10px 10px
  background-color: white
  border: 1px solid  white
  border-radius: 10px

  .key
    margin-bottom: 10px
    font-size: 16px
  .key-introduce
    margin-bottom: 10px
    line-height: 20px
  .value
    margin-bottom: 20px
    white-space: break-spaces
    .value-number
      margin-top: 20px
    .value-item
      display flex
      justify-content: space-between
      height: 25px
      line-height: 25px
      font-size: 15px
      .item-value
        margin-left: 10px
        white-space nowrap
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index",
      "cube-date-picker": "@mpxjs/mpx-cube-ui/src/components/date-picker/index"
    }
  }
</script>
